module.exports = __webpack_public_path__ + "img/icon_exchange_progress.36f225cc.png";